export default "__VITE_ASSET__Cj$hTD0M__"